// import { useParams } from "react-router-dom";
import { NavLink } from "react-router";

import logo from "../../assets/logo.png";

function NavBar(props) {
    const { pageSections, setActiveTab } = props;

    return (
        <div className="navbar">
            <nav>
                <ul>
                    {pageSections.map((item, i) => {
                        return (
                            <li>
                                <NavLink
                                    key={i}
                                    className="changeBackground"
                                    to={item.path}
                                    onClick={() => setActiveTab(item.linkName)}
                                >
                                    {item.linkName}
                                </NavLink>
                            </li>
                        )
                    })}
                </ul>
            </nav>
            <div className="monogram">
                <NavLink to="/"><img src={logo} alt="Caitlin Klotz" /></NavLink>
            </div>
        </div>
    );
};

export default NavBar;